import { ServerError, ServerParseError } from '@apollo/client';

const isServerError = (
  error: Error | ServerParseError | ServerError | null,
): error is ServerError | ServerParseError => {
  return (error as ServerError).statusCode !== undefined;
};

export default isServerError;
